<template>
  <div class="home">

    <div>
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('deliveries')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
                            </div>
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="px-8">
                <delivery-component :openCreateModal="openCreateModal" :keyword="keyword" :showFilters="showFilters"></delivery-component>
            </section>
      </div>
    
      
  </div>
</template>

<script>
import DeliveryComponent from '../../components/DeliveryComponent.vue'
import helper from '../../helper'

export default {
  name: 'Delivery',
  persistedFilterState: { key: 'delivery-search', fields: ['keyword'] },
  components : {
    DeliveryComponent,
   },
  data(){
    return {
        keyword :'',
        openCreateModal : false,
        showFilters: false
    }
  },
  mounted(){
    window.mixpanel.track("delivery");
    //check permissions
    if(helper.checkAccess('view_deliveries') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_deliveries') == -2) return this.$router.push({path : '/subscribe'})
  },
  methods : {
    async create(){
      this.openCreateModal = !this.openCreateModal
    }
  }
}
</script>
